import { UpperCasePipe } from "@angular/common";
import { Component, effect, ElementRef, ViewChild } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";
import { QRCodeComponent } from "angularx-qrcode";
import { UserService } from "app/services/user.service";
import * as htmlToImage from "html-to-image";
import { toast } from "ngx-sonner";

import { Subject } from "rxjs";

@Component({
  selector: "app-profile-qr-code",
  imports: [MatIconModule, QRCodeComponent, UpperCasePipe],
  templateUrl: "./profile-qr-code.component.html",
  standalone: true,
})
export class ProfileQrCodeComponentMobile {
  @ViewChild("qrContainer", { static: true }) qrContainer: ElementRef;

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  protected toast = toast;

  public businessCardUrl: string;
  public currentRoute: string;
  public profile;
  public blobFile: File;
  public isLoading = false;

  constructor(
    private _userService: UserService,
    private bottomRef: MatBottomSheetRef<ProfileQrCodeComponentMobile>,
    private router: Router
  ) {
    effect(() => {
      const user = this._userService.user();

      if (user) {
        this.currentRoute = user.userId;

        this.businessCardUrl = `${window.location.origin}/p/${user.userId}`;
        this.profile = user;
      }
    });
  }

  async share() {
    this.isLoading = true;

    const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(
      navigator.userAgent
    );

    let TEXT = "Tap into the link or scan QR code to see my business card:";

    if (!navigator.share) {
      this.toast.error("Web Share API not supported", {
        position: "top-center",
      });
      this.isLoading = false;
      return;
    }

    const qrContainer = this.qrContainer.nativeElement;

    const filterFunction = (node) => {
      return node.id !== "button";
    };

    let scale = 2;

    const options = {
      filter: filterFunction,
      height: qrContainer.clientHeight * scale,
      width: qrContainer.clientWidth * scale,
      style: {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left",
      },
    };

    await htmlToImage.toBlob(qrContainer, options).then(() => {
      htmlToImage.toBlob(qrContainer, options).then(() => {
        htmlToImage.toBlob(qrContainer, options).then((res) => {
          const file = new File([res], "qrcode.png", { type: "image/png" });

          let data = IS_SAFARI
            ? { files: [file] }
            : { files: [file], text: TEXT, url: this.businessCardUrl };

          navigator
            .share(data)
            .then(() => {
              if (IS_SAFARI) {
                let dataText = {
                  text: TEXT,
                  url: this.businessCardUrl,
                };
                navigator.share(dataText);
              }
              this.isLoading = false;
            })
            .catch((err) => {
              this.toast.error(err, {
                position: "top-center",
              });
              this.isLoading = false;
            });
        });
      });
    });
  }

  navigateToBusinessCard() {
    this.router
      .navigate([`p/${this.currentRoute}`])
      .then(() => this.closeDialog());
  }

  closeDialog() {
    this.bottomRef.dismiss();
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
